import React, { useEffect } from 'react';

const PAGE_LEVEL_ADS_FLAG = '__vkPageLevelAdsEnabled';

const AdCard = () => {

  useEffect(() => {
    if (window[PAGE_LEVEL_ADS_FLAG]) {
      return;
    }

    const initPageLevelAds = () => {
      if (window[PAGE_LEVEL_ADS_FLAG]) {
        return;
      }

      if (!window.adsbygoogle) {
        return;
      }

      try {
        (window.adsbygoogle = window.adsbygoogle || []).push({
          google_ad_client: 'ca-pub-8182238537019150',
          enable_page_level_ads: true,
        });
        window[PAGE_LEVEL_ADS_FLAG] = true;
      } catch (error) {
        const message = `${error?.message || ''}`;
        if (message.includes("Only one 'enable_page_level_ads' allowed per page")) {
          // Another init already happened; mark as initialized and stop retrying/logging.
          window[PAGE_LEVEL_ADS_FLAG] = true;
          return;
        }
        console.error('Page-level ad init error:', error);
      }
    };

    initPageLevelAds();

    // In case the AdSense script loads after mount, try once again on window load.
    window.addEventListener('load', initPageLevelAds);

    return () => {
      window.removeEventListener('load', initPageLevelAds);
    };
  }, []);

  // Banner ad UI is intentionally disabled for now.
  // Fullscreen/page-level ads are controlled by AdSense account settings.
  return null;
};

export default AdCard;